import React from "react";
import {SearchForm} from "./searchForm"
import MaterielTypeTree from "./materielTypeTree"
import MaterielTypeForm from "./materielTypeForm"

const MaterielType = ():JSX.Element => {
    return (
        <>
        <SearchForm/>
        <div className="flex">
            <MaterielTypeTree/>
            <MaterielTypeForm/>
        </div>
    </>
    )
}
export default MaterielType